// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AirAirPowerReferenceFilterController from "./air_air_power_reference_filter_controller"
application.register("air-air-power-reference-filter", AirAirPowerReferenceFilterController)

import AirAirRoomSelectionController from "./air_air_room_selection_controller"
application.register("air-air-room-selection", AirAirRoomSelectionController)

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import AttributeToggleController from "./attribute_toggle_controller"
application.register("attribute-toggle", AttributeToggleController)

import AutoReloadTurboFrameController from "./auto_reload_turbo_frame_controller"
application.register("auto-reload-turbo-frame", AutoReloadTurboFrameController)

import AxeptioController from "./axeptio_controller"
application.register("axeptio", AxeptioController)

import BarChartController from "./bar_chart_controller"
application.register("bar-chart", BarChartController)

import BarStackedChartController from "./bar_stacked_chart_controller"
application.register("bar-stacked-chart", BarStackedChartController)

import BlurInputController from "./blur_input_controller"
application.register("blur-input", BlurInputController)

import CarryAttributeOnSubmitController from "./carry_attribute_on_submit_controller"
application.register("carry-attribute-on-submit", CarryAttributeOnSubmitController)

import CheckboxStateManagerController from "./checkbox_state_manager_controller"
application.register("checkbox-state-manager", CheckboxStateManagerController)

import CleanInputController from "./clean_input_controller"
application.register("clean-input", CleanInputController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CollapsibleSectionFormInputController from "./collapsible_section_form_input_controller"
application.register("collapsible-section-form-input", CollapsibleSectionFormInputController)

import ConfirmChangeController from "./confirm_change_controller"
application.register("confirm-change", ConfirmChangeController)

import ConfirmLegalIdChangeController from "./confirm_legal_id_change_controller"
application.register("confirm-legal-id-change", ConfirmLegalIdChangeController)

import ConfirmToEnableController from "./confirm_to_enable_controller"
application.register("confirm-to-enable", ConfirmToEnableController)

import ConsoleMessageController from "./console_message_controller"
application.register("console-message", ConsoleMessageController)

import DataLayerPushController from "./data_layer_push_controller"
application.register("data-layer-push", DataLayerPushController)

import DecompositionRefreshController from "./decomposition_refresh_controller"
application.register("decomposition-refresh", DecompositionRefreshController)

import DependentCheckboxesController from "./dependent_checkboxes_controller"
application.register("dependent-checkboxes", DependentCheckboxesController)

import DeselectableRadioController from "./deselectable_radio_controller"
application.register("deselectable-radio", DeselectableRadioController)

import DialogCloseTrackingController from "./dialog_close_tracking_controller"
application.register("dialog-close-tracking", DialogCloseTrackingController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DispatchEventController from "./dispatch_event_controller"
application.register("dispatch-event", DispatchEventController)

import DisplayToggleController from "./display_toggle_controller"
application.register("display-toggle", DisplayToggleController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DropdownFloatingController from "./dropdown_floating_controller"
application.register("dropdown-floating", DropdownFloatingController)

import DualRangeInputController from "./dual_range_input_controller"
application.register("dual-range-input", DualRangeInputController)

import EnableWhenFilledController from "./enable_when_filled_controller"
application.register("enable-when-filled", EnableWhenFilledController)

import ExclusiveCheckboxController from "./exclusive_checkbox_controller"
application.register("exclusive-checkbox", ExclusiveCheckboxController)

import FieldDynamicSuffixController from "./field_dynamic_suffix_controller"
application.register("field-dynamic-suffix", FieldDynamicSuffixController)

import FileDropzoneController from "./file_dropzone_controller"
application.register("file-dropzone", FileDropzoneController)

import FilledController from "./filled_controller"
application.register("filled", FilledController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FormValidationLandingController from "./form_validation_landing_controller"
application.register("form-validation-landing", FormValidationLandingController)

import HighlightController from "./highlight_controller"
application.register("highlight", HighlightController)

import HorizontalScrollIndicatorController from "./horizontal_scroll_indicator_controller"
application.register("horizontal-scroll-indicator", HorizontalScrollIndicatorController)

import HovercardController from "./hovercard_controller"
application.register("hovercard", HovercardController)

import IframeNavigationRequestController from "./iframe_navigation_request_controller"
application.register("iframe-navigation-request", IframeNavigationRequestController)

import IframeReloadRequestController from "./iframe_reload_request_controller"
application.register("iframe-reload-request", IframeReloadRequestController)

import ImgDelayedLoadController from "./img_delayed_load_controller"
application.register("img-delayed-load", ImgDelayedLoadController)

import InitialstateHousingController from "./initialstate_housing_controller"
application.register("initialstate-housing", InitialstateHousingController)

import InitialstateRoomPopoverController from "./initialstate_room_popover_controller"
application.register("initialstate-room-popover", InitialstateRoomPopoverController)

import Integrations__MapsController from "./integrations/maps_controller"
application.register("integrations--maps", Integrations__MapsController)

import ListEntriesController from "./list_entries_controller"
application.register("list-entries", ListEntriesController)

import ListFilterTitlesController from "./list_filter_titles_controller"
application.register("list-filter-titles", ListFilterTitlesController)

import LiveCheckboxCountController from "./live_checkbox_count_controller"
application.register("live-checkbox-count", LiveCheckboxCountController)

import LodViewerController from "./lod_viewer_controller"
application.register("lod-viewer", LodViewerController)

import LogoPreviewController from "./logo_preview_controller"
application.register("logo-preview", LogoPreviewController)

import MapAddressConfirmController from "./map_address_confirm_controller"
application.register("map-address-confirm", MapAddressConfirmController)

import MapRenderBuildingController from "./map_render_building_controller"
application.register("map-render-building", MapRenderBuildingController)

import MirrorValueController from "./mirror_value_controller"
application.register("mirror-value", MirrorValueController)

import NeedsPrioritySortController from "./needs_priority_sort_controller"
application.register("needs-priority-sort", NeedsPrioritySortController)

import NumberInputController from "./number_input_controller"
application.register("number-input", NumberInputController)

import PacAirAirDimensioningPanelController from "./pac_air_air_dimensioning_panel_controller"
application.register("pac-air-air-dimensioning-panel", PacAirAirDimensioningPanelController)

import PartnershipTypeSelectController from "./partnership_type_select_controller"
application.register("partnership-type-select", PartnershipTypeSelectController)

import PdfExportSummaryFlagController from "./pdf_export_summary_flag_controller"
application.register("pdf-export-summary-flag", PdfExportSummaryFlagController)

import PhoneInputController from "./phone_input_controller"
application.register("phone-input", PhoneInputController)

import PieChartController from "./pie_chart_controller"
application.register("pie-chart", PieChartController)

import PricesExportButtonController from "./prices_export_button_controller"
application.register("prices-export-button", PricesExportButtonController)

import ProspectionController from "./prospection_controller"
application.register("prospection", ProspectionController)

import QuillEditorController from "./quill_editor_controller"
application.register("quill-editor", QuillEditorController)

import RangeInputController from "./range_input_controller"
application.register("range-input", RangeInputController)

import RefreshPageController from "./refresh_page_controller"
application.register("refresh-page", RefreshPageController)

import ReloadTurboFrameController from "./reload_turbo_frame_controller"
application.register("reload-turbo-frame", ReloadTurboFrameController)

import RemovableFieldController from "./removable_field_controller"
application.register("removable-field", RemovableFieldController)

import RemoveBlockController from "./remove_block_controller"
application.register("remove-block", RemoveBlockController)

import ReplaceStateController from "./replace_state_controller"
application.register("replace-state", ReplaceStateController)

import RestoreAttributeOnMorphController from "./restore_attribute_on_morph_controller"
application.register("restore-attribute-on-morph", RestoreAttributeOnMorphController)

import RoomPickerArmController from "./room_picker_arm_controller"
application.register("room-picker-arm", RoomPickerArmController)

import ScaleToFitController from "./scale_to_fit_controller"
application.register("scale-to-fit", ScaleToFitController)

import ScenarioCardsController from "./scenario_cards_controller"
application.register("scenario-cards", ScenarioCardsController)

import ScenarioFamilyController from "./scenario_family_controller"
application.register("scenario-family", ScenarioFamilyController)

import ScrollIntoMeController from "./scroll_into_me_controller"
application.register("scroll-into-me", ScrollIntoMeController)

import ScrollPreserveController from "./scroll_preserve_controller"
application.register("scroll-preserve", ScrollPreserveController)

import ScrollStepsController from "./scroll_steps_controller"
application.register("scroll-steps", ScrollStepsController)

import ScrollToFirstController from "./scroll_to_first_controller"
application.register("scroll-to-first", ScrollToFirstController)

import SelectorController from "./selector_controller"
application.register("selector", SelectorController)

import SelfDestructController from "./self_destruct_controller"
application.register("self-destruct", SelfDestructController)

import SetInputValueController from "./set_input_value_controller"
application.register("set-input-value", SetInputValueController)

import SidebarCollapseController from "./sidebar_collapse_controller"
application.register("sidebar-collapse", SidebarCollapseController)

import SimulationRequestStatusMenuController from "./simulation_request_status_menu_controller"
application.register("simulation-request-status-menu", SimulationRequestStatusMenuController)

import SimulatorResultsLoaderController from "./simulator_results_loader_controller"
application.register("simulator-results-loader", SimulatorResultsLoaderController)

import SimulatorStreetViewController from "./simulator_street_view_controller"
application.register("simulator-street-view", SimulatorStreetViewController)

import SingleSubmitController from "./single_submit_controller"
application.register("single-submit", SingleSubmitController)

import SliderController from "./slider_controller"
application.register("slider", SliderController)

import SortableFieldsController from "./sortable_fields_controller"
application.register("sortable-fields", SortableFieldsController)

import SubmitFormController from "./submit_form_controller"
application.register("submit-form", SubmitFormController)

import SubmitOwnerFormController from "./submit_owner_form_controller"
application.register("submit-owner-form", SubmitOwnerFormController)

import SvgTextChangerController from "./svg_text_changer_controller"
application.register("svg-text-changer", SvgTextChangerController)

import SyncCheckboxesController from "./sync_checkboxes_controller"
application.register("sync-checkboxes", SyncCheckboxesController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TeamCsvExportButtonController from "./team_csv_export_button_controller"
application.register("team-csv-export-button", TeamCsvExportButtonController)

import TextAreaAutoResizeController from "./text_area_auto_resize_controller"
application.register("text-area-auto-resize", TextAreaAutoResizeController)

import ThreeDRemoteViewerController from "./three_d_remote_viewer_controller"
application.register("three-d-remote-viewer", ThreeDRemoteViewerController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import ValueToggleController from "./value_toggle_controller"
application.register("value-toggle", ValueToggleController)

import VisitController from "./visit_controller"
application.register("visit", VisitController)

import WindowMessageController from "./window_message_controller"
application.register("window-message", WindowMessageController)

import WorkSelectorController from "./work_selector_controller"
application.register("work-selector", WorkSelectorController)
